import { Component, Input } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Contract } from '@models/models';
import { PlatformLocation } from '@angular/common';

@Component({
	selector: 'edit-contract-modal',
	template: require('./edit-contract-modal.component.html')
})
export class EditContractModalComponent {
	@Input() btnDisabled = false;
	@Input() isFixed: boolean;
	@Input() action: string;
	@Input() contractToEdit: Contract;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private location: PlatformLocation
	) {
		location.onPopState(() => this.onDismiss());
	}

	onDismiss(): void {
		if (!this.btnDisabled) {
			this.modalService.setModalData({
				action: 'CLOSE_MODAL',
				props: null
			});
		}
	}

	saveEditedContract(): void {
		if (this.contractToEdit && this.contractToEdit.text !== '') {
			this.modalService.setModalData({
				action: this.action,
				props: JSON.parse(JSON.stringify(this.contractToEdit))
			});
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts